import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Description = styled.div`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: ${token('space.300')};

    a {
        color: ${token('color.text.accent.blue')};
        cursor: pointer;
        text-decoration: none;
    }
`;

export const DragDropSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${token('color.text.subtlest')};
    font-size: 14px;
    font-weight: 400;
    border-radius: 3px;
    border: 1px dashed ${token('color.border.accent.gray')};
    padding: ${token('space.250')};

    .text {
        margin: ${token('space.150')} 0;
    }
`;

export const FooterContent = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;

    button[data-testid='cancel-btn'] {
        margin-left: ${token('space.100')};

        span {
            color: ${token('color.text.subtlest')};
        }
    }
`;

export const Support = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: ${token('color.text.subtlest')};
    cursor: pointer;

    span[data-testid='contact-support-icon'] {
        margin-left: ${token('space.100')};
    }
`;
